import { Fragment, Key, lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import HomeLayout from "../layout/home-layout";
import { AuthGuard, ReversGuard } from "./guards";

import SuspenseScreen from "./suspense-screen";

function Router() {
  const routes: any = [
    {
      path: "/",
      layout: HomeLayout,
      routes: [
        { path: "about", element: lazy(() => import("../pages/about")) },
        { path: "rules", element: lazy(() => import("../pages/rules")) },
        { path: "register", element: lazy(() => import("../pages/register")) },
        // { path: "feedback", element: lazy(() => import("../pages/feedback")) },
        //{ path: "mock", element: lazy(() => import("../pages/hunt")) },
        // { path: "selection-round-mock", element: lazy(() => import("../pages/mockup")) },
        // { path: "135", element: lazy(() => import("../pages/admin")) },
        // { path: "246", element: lazy(() => import("../pages/admin/2")) },
        // {
        //   path: "selection-round",
        //   element: lazy(() => import("../pages/selection")),
        // },
        // {
        //   path: "selection-round-links",
        //   element: lazy(() => import("../pages/selection-links")),
        // },
        //{ path: "tclst224djmallfhsgct", element: lazy(() => import("../pages/selection")) },
        {
          path: "scavenger-hunt",
          element: lazy(() => import("../pages/hunt")),
        },
        {
          path: "scavenger-hunt/help-tool",
          element: lazy(() => import("../pages/hunt/puzzle/QRTool")),
        },
        //Proofing Paths
        // {
        //   path: "scavenger-hunt/r1",element: lazy(() => import("../pages/hunt/proofing/r1proof")),
        // },
        // {
        //   path: "scavenger-hunt/r2",element: lazy(() => import("../pages/hunt/proofing/r2proof")),
        // },
        // {
        //   path: "scavenger-hunt/r3",element: lazy(() => import("../pages/hunt/proofing/r3proof")),
        // },
        // {
        //   path: "scavenger-hunt/r4",element: lazy(() => import("../pages/hunt/proofing/r4proof")),
        // },
        // {
        //   path: "scavenger-hunt/r5",element: lazy(() => import("../pages/hunt/proofing/r5proof")),
        // },
        // {
        //   path: "scavenger-hunt/r6",element: lazy(() => import("../pages/hunt/proofing/r6proof")),
        // },
        // {
        //   path: "scavenger-hunt/p1",element: lazy(() => import("../pages/hunt/proofing/p1proof")),
        // },
        // {
        //   path: "scavenger-hunt/p2",element: lazy(() => import("../pages/hunt/proofing/p2proof")),
        // },
        // {
        //   path: "scavenger-hunt/p3",element: lazy(() => import("../pages/hunt/proofing/p3proof")),
        // },
        // {
        //   path: "scavenger-hunt/p4",element: lazy(() => import("../pages/hunt/proofing/p4proof")),
        // },
        // {
        //   path: "scavenger-hunt/p5",element: lazy(() => import("../pages/hunt/proofing/p5proof")),
        // },
        // {
        //   path: "scavenger-hunt/p6",element: lazy(() => import("../pages/hunt/proofing/p6proof")),
        // },



        //End of Proofing Paths

        { element: lazy(() => import("../pages/home")), index: true },
      ],
    },
    // {
    //   path: "/about",
    //   layout: HomeLayout,
    //   // guard: AuthGuard,
    //   routes: [{ element: lazy(() => import("../pages/about")) }],
    // },
    // {
    //   path: "/auth",
    //   layout: HomeLayout,
    //   // guard: ReversGuard,
    //   routes: [
    //     { path: "login", element: lazy(() => import("../pages/auth/login")) },
    //     { path: "register", element: lazy(() => import("../pages/auth/register")) },
    //     { element: lazy(() => import("../pages/tutors")) },
    //   ],
    // },
    // {
    //   path: "/tutors",
    //   layout: HomeLayout,
    //   routes: [{ path: ":id", element: lazy(() => import("../pages/tutors/profile")) }, { element: lazy(() => import("../pages/tutors")) }],
    // },
    // {
    //   path: "/about-us",
    //   layout: HomeLayout,
    //   routes: [{ path: "results", element: lazy(() => import("../pages/about-us/results")) }, { element: lazy(() => import("../pages/about-us")) }],
    // },

    { path: "*", layout: HomeLayout, element: lazy(() => import("./404")) },
  ];

  const routeRender = (
    route: {
      index: any;
      element: any;
      guard: any;
      layout: any;
      path: string;
      routes: any[];
    },
    i: Key | null | undefined
  ) => {
    const Element = route.element ? route.element : Fragment;
    const Guard = route.guard ? route.guard : Fragment;
    const Layout = route.layout ? route.layout : Fragment;
    return (
      <Route
        key={i}
        index={route.index}
        path={route.path}
        element={
          <Guard>
            <Layout>
              <Suspense fallback={<SuspenseScreen />}>
                <Element />
              </Suspense>
            </Layout>
          </Guard>
        }
      >
        {route.routes && route.routes.map(routeRender)}
      </Route>
    );
  };
  return <Routes>{routes.map(routeRender)}</Routes>;
}

export default Router;
